import * as React from "react";
import { Spinner } from "components/common";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
import { useInputMetricsFor } from "components/inputs/InputsOveriew/InputMetricsContext";
import { METRIC_COLUMN_IDS } from "components/inputs/InputsOveriew/metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.extractorCount;
const ExtractorCountCell = ({ input }) => {
  const { metrics, isInitialLoading, isError } = useInputMetricsFor(input.id);
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || (metrics == null ? void 0 : metrics.extractor_count) === void 0) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": `No extractor count available for input ${input.title}` }, "\u2014");
  }
  return /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId: input.id,
      section: SECTION_NAME,
      count: metrics.extractor_count,
      label: `extractors for ${input.title}`
    }
  );
};
export default ExtractorCountCell;
